export const cols = [{
	prop: 'orderType',
	label: '单据类型',
	width: '120',
	align: 'center'
}, {
	prop: 'orderNo',
	label: '单据编号',
	width: '200',
	align: 'center'
}, {
	prop: 'createDate',
	label: '下单时间',
	width: '160',
	align: 'center'
}, {
	prop: 'entName',
	label: '供货商名称',
	width: '180',
	align: 'center'
}, {
	prop: 'shopName',
	label: '供货商店铺名称',
	width: '180',
	align: 'center'
}, {
	prop: 'buyerName',
	label: '采购门店名称',
	width: '160',
	align: 'center'
}, {
	prop: 'customerName',
	label: '客户名称',
	width: '180',
	align: 'center'
}, {
	prop: 'orderSumMoney',
	label: '单据总额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'freight',
	label: '运费',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'supplySumMoney',
	label: '商品总额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'discountPrice',
	label: '优惠金额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'platProportionSumMoney',
	label: '平台佣金',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'platServiceSumMoney',
	label: '支付服务费',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realReceiveSumMoney',
	label: '实收总额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'xxSumMoney',
	label: '线下支付总额',
	width: '140',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'slqbSumMoney',
	label: '商龙钱包支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'zfbSumMoney',
	label: '支付宝支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'wxSumMoney',
	label: '微信支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'yfhkSumMoney',
	label: '预付货款支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'getter',
	label: '收货人',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'tel',
	label: '联系电话',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'address',
	label: '收货地址',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'companycode',
	label: '物流公司',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'ffnumber',
	label: '物流单号',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}]
